let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c8UG3")).then(() => parcelRequire('bh48U'));